import axios from 'axios';
import { forwardRef, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { userSelector } from '../../../../appStore/commonSlice';
import { USERAPI } from '../../../../const';
import Form from '../../../CompUtils/Form';
import { InscripcionForm } from './InscripcionForm';
import Terminos from './Terminos';

type Props = {
  idLlamadoConcurso: number | undefined;
  ubicacionEstructural: any;
  requisitos: any;
  setRequisitos: (requisitos: any) => void;
  concurso: any;
};

interface UserDataInterface {
  nombre?: string;
  apellido?: string;
  cuil?: string;
}
export const Step1AndStep2ToPrint = forwardRef((props: any, ref: any) => {
  const { puesto, concurso, requisitos, setRequisitos, ubicacionEstructural } = props;

  const [userData, setUserData] = useState<UserDataInterface>({});
  const user = useSelector(userSelector);
  // IDconcurso, Estructura/Jurisdircción y Cargo,CUIL, nombre y apellido
  // fecha y hora de la inscripción
  useEffect(() => {
    axios
      .get(`${USERAPI}/usuarios/cuil/${user.cuil}`)
      .then((res) => {
        setUserData(res.data);
      })
      .catch((err) => console.error(err));
  }, []);

  return (
    <div ref={ref}>
      <Form>
        <div className="row">
          <div className="col-12">
            <p>
              <h4>Datos del postulante</h4>
            </p>
            <hr />
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <p>
              <strong>Nombre y Apellido:</strong> {userData.nombre} {userData.apellido}
            </p>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <p>
              <strong>CUIL:</strong> {userData.cuil}
            </p>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <p>
              <strong>Fecha y hora de la inscripción:</strong> {new Date().toLocaleString()}
            </p>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <p>
              <strong>Concurso:</strong> {concurso.idLlamadoConcurso}
            </p>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <p>
              <strong>Estructura/Jurisdicción:</strong> {ubicacionEstructural}
            </p>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <p>
              <strong>Cargo:</strong> {puesto.denominacion}
            </p>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <p>
              <h4>Requisitos:</h4>
            </p>
          </div>
        </div>
        <InscripcionForm requisitos={requisitos} setRequisitos={setRequisitos} />
        <div className="row">
          <div className="col-12">
            <p>
              <hr />
              <h4>Terminos y Condiciones.</h4>
              <hr />
            </p>
            <>
              <Terminos />
            </>
          </div>
        </div>
      </Form>
    </div>
  );
});
